import { CalledsService } from './../../../auth/_services/calleds.service';
import { Called } from './../../../auth/_models/called';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calleds-list',
  templateUrl: './calleds-list.component.html',
  styleUrls: ['./calleds-list.component.css']
})
export class CalledsListComponent implements OnInit {

  calleds: Observable<Called[]>;

  constructor(
    private _service: CalledsService
  ) { }

  ngOnInit() {
    this.calleds = this._service.getCalleds();
  }

  onSelect(called: Called) {
    this._service.selectCalled(called);
  }
}
